import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { LayoutComponent } from './layout.component';
import { SideBarLeftModule } from './sidebar-left/sidebar-left.module';
import { BreadcrumbsModule } from './bread-crumbs/bread-crumbs.module';
import { ContentModule } from './content/content.module';
import { AngularMaterialModule } from '../material.module';
import { MastersModule } from '../masters/masters.module';
import { DashboardModule } from '../dashboard/dashboard.module';
import { PipeModule } from '../shared/pipes/pipes.module';
import { CompanyBranchSelectionComponent } from './company-branch-selection/company-branch-selection.component';
import { SharedModule } from '../shared/shared.module';
import { ReactiveFormsModule } from '@angular/forms';


@NgModule({
  imports: [CommonModule,  
    RouterModule,SideBarLeftModule,BreadcrumbsModule,ContentModule,
    AngularMaterialModule,MastersModule,
    DashboardModule,PipeModule,SharedModule,ReactiveFormsModule
  ],
  exports: [
  ],
  declarations: [LayoutComponent, CompanyBranchSelectionComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
  
})
export class LayoutModule {

}